var data = [
    {
        "transporter_name":"Transporter 1",
        "transporter_id":"IND00987",
        "category":[
            {
                "indent_status":"pending",
                "count":2
            },
            {
                "indent_status":"accepted",
                "count":5
            },
            {
                "indent_status":"rejected",
                "count":2
            },
            {
                "indent_status":"allocated",
                "count":15
            }
        ],
        "total_category_value":20
    },
    {
        "transporter_name":"Transporter 2",
        "transporter_id":"IND00987",
        "category":[
            {
                "indent_status":"pending",
                "count":4
            },
            {
                "indent_status":"accepted",
                "count":8
            },
            {
                "indent_status":"rejected",
                "count":2
            },
            {
                "indent_status":"allocated",
                "count":6
            }
        ],
        "total_category_value":20
    },
    {
        "transporter_name":"Transporter 3",
        "transporter_id":"IND00987",
        "category":[
            {
                "indent_status":"pending",
                "count":3
            },
            {
                "indent_status":"accepted",
                "count": 10
            },
            {
                "indent_status":"rejected",
                "count":1
            },
            {
                "indent_status":"allocated",
                "count":5
            }
        ],
        "total_category_value":20
    },
    {
        "transporter_name":"Transporter 4",
        "transporter_id":"IND00987",
        "category":[
            {
                "indent_status":"pending",
                "count":6
            },
            {
                "indent_status":"accepted",
                "count":1
            },
            {
                "indent_status":"rejected",
                "count":3
            },
            {
                "indent_status":"allocated",
                "count":6
            }
        ],
        "total_category_value":20
    },
    
]
export default data